export default __webpack_public_path__ + "static/media/img13.a0b7807e.svg";